import { useEffect } from 'react'

const PIXEL_ID = '1005317285129733'

declare global {
  interface Window {
    fbq: (...args: unknown[]) => void
    _fbq: (...args: unknown[]) => void
  }
}

function initPixel() {
  if (window.fbq) return

  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })

  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', PIXEL_ID)
  window.fbq('track', 'PageView')
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()
  }, [])
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Código Oscuro',
      content_type: 'product',
      value: 6.36,
      currency: 'USD',
    })
  }
}
